import { PUBLIC_MAGENTO_ENDPOINT } from '$env/static/public';


/**
 * Subscribe an email to the newsletter.
 */
export async function subscribeToNewsletter(email: string) {
  await fetch(
    // TODO[i18n]: how do we subscribe them to the right scope? If you subscribe on /es/ you should
		//   not get the French newsletter.
		`${PUBLIC_MAGENTO_ENDPOINT}/rest/V1/newsletter/subscription/${email}`,
    { method: "POST", headers: { "Content-Type": "application/json", Accept: 'application/json' } }
  );
}
